import { MenuItem } from "@mui/material";
import LayoutMaster from "components/layout/layout_master";
import { alertWithSuccessMessage } from "components/modal/success_modal";
import {
  MuiTextFieldFrom,
  MuiTextFieldFromSelect,
  MuiTextFieldFromSendButton,
} from "components/view/text_field_from";
import { CenterProps } from "lib/all_type/center_props";
import {
  CheckWithPrefix,
  CheckWithPrefixResponse,
} from "lib/infomation_vender/document";
import { AppReducerStateProps } from "lib/store";
import getinfo from "lib/worker/api/getinfo";
import {
  apigetbankonlywebsite,
  GetBankTypeAllResponse,
} from "lib/worker/api/get_bank_type_all";
import send_otp_update_bank from "lib/worker/api/send_otp_update_bank";
import update_bank_account from "lib/worker/api/update_bank_account";
import { prefix } from "lib/worker/client";
import { GetServerSideProps } from "next";
import Link from "next/link";
import { useRouter } from "next/router";
import React from "react";
import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { connect } from "react-redux";
import Img from "react-cloudimage-responsive";
import { MaxButton, StatusMaxButton } from "components/view/button";

interface Props extends CenterProps {
  isLogin: boolean;
  state: AppReducerStateProps;
  banks: GetBankTypeAllResponse[];
  infomation: CheckWithPrefixResponse;
}

function AddBankPage(props: Props) {
  const [firstname, setFirstname] = useState<string>();
  const [lastname, setLastname] = useState<string>();
  const [bankaccountID, setBankAccountID] = useState<number>();
  const [banknumber, setBanknumber] = useState<string>();
  const [tel, setTel] = useState<string>();
  const [token, setToken] = useState<string>();
  const [pin, setPin] = useState<string>();
  const router = useRouter();
  const [lineid, setlineid] = useState<string | null | undefined>(null);

  useEffect(() => {
    const infomations = CheckWithPrefix({ host: props.infomation.domain });
    setlineid(infomations.lineidchat);
  }, []);

  useEffect(() => {
    getinfo().then((json) => {
      const { BankName, Tel } = json;
      if (BankName != null) {
        const bankName = BankName?.split(" ");
        setFirstname(bankName.slice(0, -1).join("").trim());
        setLastname(bankName.splice(1, bankName.length).join("").trim());
      }

      if (Tel != null) {
        setTel(Tel);
      }
    });
  }, []);

  const requestOTP = (event: any) => {
    event.preventDefault();
    send_otp_update_bank({ tel: tel, prefix: prefix ?? "" })
      .then((json) => {
        setToken(json.data?.token ?? "");
      })
      .catch((error) => {
        props.alertWithMessage(error.response.data.message);
      });
  };

  const onSubmit = (event: any) => {
    event.preventDefault();
    update_bank_account({
      bank_name: `${firstname} ${lastname}`.trim(),
      bank_type_id: bankaccountID,
      bank_number: banknumber,
      tel: tel,
      token: token,
      pin: pin,
      prefix: prefix ?? "",
    })
      .then(() => {
        alertWithSuccessMessage("สำเร็จ");
        router.push("/bank");
      })
      .catch((error) => {
        props.alertWithMessage(error.response.data.message);
      });
  };

  return (
    <LayoutMaster
      content_setting={{
        title: "เพิ่มธนาคาร รับรหัส OTP เพื่อยืนย้น​ ธนาคาร",
        description:
          "สามารถ เพิ่มบัญชี ธนาคาร ได้อย่าง รวดเร็ว เพียงไม่กี่ ขั้นตอน จากนั้น รอรับรหัส OTP เพื่อยืนยัน พร้อมให้บริการ ตลอด 24 ชม. บาคาร่า สล็อต แทงบอล",
      }}
      information={props.infomation}
    >
      <div className="container children-top-margin-top-10">
        <h1 className="text-center">เพิ่มบัญชีธนาคาร</h1>
        <Form>
          <MuiTextFieldFrom
            title="ชื่อจริง"
            value={firstname}
            disable={props.state.member.getinfo.BankName != null}
            type="firstname"
            className="margin-top-20"
            onChange={(e) => {
              setFirstname(e.target.value);
            }}
          ></MuiTextFieldFrom>

          <MuiTextFieldFrom
            title="นามสกุล"
            value={lastname}
            disable={props.state.member.getinfo.BankName != null}
            type="lastname"
            className="margin-top-20"
            onChange={(e) => {
              setLastname(e.target.value);
            }}
          ></MuiTextFieldFrom>
          <MuiTextFieldFromSelect title="ธนาคาร" className="margin-top-20">
            {props.banks.map((value) => {
              return (
                <MenuItem
                  key={value.ID}
                  value={value.ID}
                  onClick={() => {
                    setBankAccountID(value.ID);
                  }}
                >
                  <div
                    style={{
                      height: 30,
                      width: 30,
                      borderRadius: 4,
                      backgroundColor: value.Color ?? "white",
                      float: "left",
                    }}
                  >
                    <div style={{ padding: 3 }}>
                      <Img src={value.Image ?? ""}></Img>
                    </div>
                  </div>{" "}
                  <div
                    style={{
                      float: "left",
                      marginLeft: 10,
                      marginTop: 3,
                    }}
                  >
                    {value.Type}
                  </div>
                </MenuItem>
              );
            })}
          </MuiTextFieldFromSelect>

          <MuiTextFieldFrom
            title={
              bankaccountID == 14 ? "ระบุเบอร์มือถือ Truewallet" : "เลขที่บัญชี"
            }
            despication="*ชื่อ-นามสกุล ต้องตรงกับ บช ธนาคาร"
            value={banknumber}
            disable={props.state.member.getinfo.BankName != null}
            type="banknumber"
            className="margin-top-20"
            onChange={(e) => {
              setBanknumber(e.target.value);
            }}
          ></MuiTextFieldFrom>

          <MuiTextFieldFromSendButton
            className="margin-top-20"
            title="เบอร์โทรศัพท์"
            titleButton="ส่ง OTP"
            value={tel}
            type="phonenumber"
            disable={props.state.member.getinfo.Tel != ""}
            onChange={(e) => {
              setTel(e.target.value);
            }}
            onClick={requestOTP}
          ></MuiTextFieldFromSendButton>

          <MuiTextFieldFrom
            title={"ระบุ OTP"}
            value={pin}
            disable={token == null}
            type="otp"
            className="margin-top-20"
            onChange={(e) => {
              setPin(e.target.value);
            }}
          ></MuiTextFieldFrom>
          <Form.Group>
            <MaxButton
              lock={token == null}
              className="margin-top-20"
              title="ยืนยัน"
              status={StatusMaxButton.submit}
              onClick={onSubmit}
            ></MaxButton>
          </Form.Group>
        </Form>

        <h2
          className="font-red margin-top-20"
          style={{ fontSize: 16, marginLeft: 10 }}
        >
          *พบปัญหากรุณาติดต่อเจ้าหน้าที่ผ่านช่องทางแชท{" "}
          {router.pathname.includes("contact") == false && (
            <>
              {" "}
              {lineid != null ? (
                <Link href={lineid}>
                  <a>
                    <span>คลิก</span>
                  </a>
                </Link>
              ) : (
                <Link href={`/contact/${prefix}`}>
                  <a>
                    <span>คลิก</span>
                  </a>
                </Link>
              )}
            </>
          )}
        </h2>
      </div>
    </LayoutMaster>
  );
}

export const getServerSideProps: GetServerSideProps<any> = async (context) => {
  const { req } = context;
  console.log("COTEXT =>", req.headers.host);
  console.log("query =>", context.query);
  const infomation = CheckWithPrefix({ host: req.headers.host as string });

  try {
    const banks = await apigetbankonlywebsite({ prefix: infomation.prefix });
    return {
      props: {
        isLogin: context.req.cookies.access_token != undefined,
        banks: banks,
        infomation: infomation,
      },
    };
  } catch (error) {
    return {
      props: {
        isLogin: context.req.cookies.access_token != undefined,
        banks: [],
      },
    };
  }
};

const mapStateToProps = (state: any) => {
  return {
    state: state,
    isLogin: state.member.isLogin,
  };
};

export default connect(mapStateToProps)(AddBankPage);
